import { colors } from "config/styles/themeColors";

const styles = {
  inputWrap: {
    "&.MuiFormControl-root": {
      width: "100%",
      "& .MuiFormLabel-root": {
        transform: "translate(14px, 9px) scale(1)",
      },
      "& .MuiFormLabel-root.Mui-focused": {
        color: "text.secondary",
        transform: "translate(14px, -9px) scale(0.75)",
      },
      "& .MuiFormLabel-root.MuiFormLabel-filled": {
        color: "text.secondary",
        transform: "translate(14px, -9px) scale(0.75)",
      },
    },
  },
  icon: (isError?: boolean) => ({
    width: "24px",
    height: "24px",
    fill: isError ? colors.error.main : colors.text.secondary,
  }),
  visibilityIcon: {
    cursor: "pointer",
    fill: colors.text.secondary,
  },
};

export default styles;
